import { Squire } from './Editor';

export default Squire;
